import {FormattedMessage, FormattedDate, FormattedTime} from 'react-intl';
import {Link} from 'react-router-dom';
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import styles from './css/Order.scss';
import Table from '../../../ui/Table';

export default class Order extends Component {
    static propTypes = {
        order: PropTypes.any,
        services: PropTypes.any
    }

    render() {
        const {order, services} = this.props;
        const img = services ? services.getIn([order.get('serviceId'), 'image', 'path']) : null;
        const status = order.getIn(['lastStatus', 'status']);

        return (
            <Table.Row className={styles.row}>
                <Table.Cell className={styles.cell}>
                    <Link to={`/orders/${order.get('code')}`}>
                        {order.get('code')}
                    </Link>
                </Table.Cell>
                <Table.Cell className={styles.cell}>
                    {order
                        ? <span>
                            <FormattedDate day='2-digit' month='2-digit' year={'numeric'}
                                value={order.get('createdAt')}/>
                            &nbsp;
                            <FormattedTime value={order.get('createdAt')}/>
                        </span>
                        : null}
                </Table.Cell>
                <Table.Cell className={styles.imageCell}>
                    {img ? <img src={`/${img}`} role='presentation' className={styles.service}/> : null}
                </Table.Cell>
                <Table.Cell className={styles.statusCell}>
                    {status ? <FormattedMessage id={status}/> : null}
                </Table.Cell>
            </Table.Row>
        );
    }
}
